import React, { useState, useEffect } from 'react';
import { carsAPI } from '../services/api';
import './CarSelector.css';

const CarSelector = ({ onSelectModel, showTitle = true }) => {
  const [models, setModels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchModels();
  }, []);

  const fetchModels = async () => {
    try {
      setLoading(true);
      const response = await carsAPI.getModels();
      // Django REST Framework returns data in results when pagination is enabled
      const data = response.data.results || response.data;
      setModels(Array.isArray(data) ? data : []);
      setError(null);
    } catch (err) {
      setError('فشل في تحميل الموديلات');
      console.error('Error fetching models:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="spinner"></div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="car-selector">
      {showTitle && <h2 className="section-title">اختر موديل سيارتك</h2>}
      {models.length === 0 ? (
        <div className="no-data">لا توجد موديلات متاحة حالياً</div>
      ) : (
        <div className="models-grid">
          {models.map((model) => (
          <div
            key={model.id}
            className="model-card card"
            onClick={() => onSelectModel(model)}
          >
            <div className="model-image-wrapper">
              {model.image_url ? (
                <img
                  src={model.image_url}
                  alt={model.name}
                  className="model-image"
                  onError={(e) => {
                    e.target.src = '/logo.png';
                  }}
                />
              ) : (
                <div className="model-image-placeholder">
                  <span className="placeholder-icon">🚗</span>
                  <span className="placeholder-text">{model.name}</span>
                </div>
              )}
            </div>
            <div className="model-info">
              <h3 className="model-name">{model.name}</h3>
              {model.year_range && (
                <p className="model-year">{model.year_range}</p>
              )}
              {model.variants_count > 0 && (
                <p className="model-variants">
                  {model.variants_count} سيارة متاحة
                </p>
              )}
            </div>
          </div>
        ))}
        </div>
      )}
    </div>
  );
};

export default CarSelector;
